// utils/ocrModel.ts
// AI OCR モード（高品質 / 標準）の永続化ヘルパー

import { indexedDBStorage } from '../services/storage/indexedDB';

export type OcrModel = 'high' | 'fast';

export const OCR_MODEL_LABELS: Record<OcrModel, string> = {
  high: '高品質',
  fast: '標準',
};

export const OCR_MODEL_DESCRIPTIONS: Record<OcrModel, string> = {
  high: '認識精度を優先します（時間がかかる場合があります）',
  fast: '結果がより早くでます（品質は標準です）',
};

const DEFAULT_MODEL: OcrModel = 'high';

/** ユーザーが選択しているデフォルトモード（次回以降の初期値） */
const PREFERENCE_KEY = 'ocrModelPreference';
/** 直近の OCR で実際に使われたモード（EditResultPage の再解析ボタン制御に使用） */
const LAST_USED_KEY = 'lastOcrUsedModel';

const isOcrModel = (v: unknown): v is OcrModel => v === 'high' || v === 'fast';

export const getOcrModelPreference = async (): Promise<OcrModel> => {
  const v = await indexedDBStorage.getItem(PREFERENCE_KEY);
  return isOcrModel(v) ? v : DEFAULT_MODEL;
};

export const setOcrModelPreference = async (model: OcrModel): Promise<void> => {
  await indexedDBStorage.setItem(PREFERENCE_KEY, model);
};

export const getLastOcrUsedModel = async (): Promise<OcrModel | null> => {
  const v = await indexedDBStorage.getItem(LAST_USED_KEY);
  return isOcrModel(v) ? v : null;
};

export const setLastOcrUsedModel = async (model: OcrModel): Promise<void> => {
  await indexedDBStorage.setItem(LAST_USED_KEY, model);
};
